import { useState } from "react"
import {
    Map,
    Placemark,
    YMaps,
} from "@pbe/react-yandex-maps";
import "./css/style.css"
export default function MapElem({coor, title}) {
    const [coordinates, setcoordinates] = useState(JSON.parse(`[${coor}]`));
    console.log(coordinates);
    
    function escapeHtml(text) {
        var map = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#039;",
            " ": "&nbsp;",
        };

        return text.replace(/[&<>"' ]/g, function (m) {
            return map[m];
        });
    }
    return (
        <YMaps
        query={{
            apikey: "92e27a44-279d-48bf-be97-d95e84154e5e",
            lang: "ru_RU",
            ns: "use-load-option",
            load: "Map,Placemark,control.ZoomControl,control.FullscreenControl,geoObject.addon.balloon",
        }}
        className="map_content_map"
    >
        <Map
                      height={"500px"}
                      width={"100%"}
                      state={{
                          center: coordinates,
                          zoom: 14,
                          controls: [
                              "zoomControl",
                              "fullscreenControl",
                          ],
                      }}
                      modules={[
                          "control.ZoomControl",
                          "control.FullscreenControl",
                      ]}
        >
            <Placemark
                modules={[
                    "geoObject.addon.balloon",
                ]}
                geometry={coordinates}
              
                options={{
                    // preset: 'islands#greenDotIconWithC/aption',
                    iconColor: '#aeca3b',
                    iconLayout: "default#image",
                    iconImageHref: `/logo_hom.png`,
                    iconImageSize: [40, 40],
                    // Смещение левого верхнего угла иконки относительно
                    // её "ножки" (точки привязки).
                    // iconImageOffset:`/logo_hom.png`,
                    controls: [],
                }}
            />
        </Map>
    </YMaps>
    )
}